<template>
  <div>
    <DxForm id="formularioMarcoComisiones" ref="formInstance" label-location="top"
      :show-colon-after-label="false" validation-group="validacionMarcoComisiones">
      <!-- xs: 768, sm: 992, md:1200 -->
      <DxColCountByScreen :xs="6" :sm="6" :md="6" :lg="6" />

      <!-- Datos del marco de comisión -->
      <DxGroupItem :col-span="6" :col-count="6">
        <DxSimpleItem data-field="marcoComisiones" editor-type="dxSelectBox" :col-span="6"
          :editor-options="{ ...getSelectBoxDefaultProperties(), ...selectMarcoComisionesOptions }">
          <DxLabel :text="$t('marcosComisiones.ui.selector')" />
          <DxRequiredRule :message="$t('marcosComisiones.validacion.marco_comisiones_requerido')" />
        </DxSimpleItem>
      </DxGroupItem>

    </DxForm>
  </div>
</template>

<script setup lang="ts">
import { messageBoxResult } from '@components/dialogs/message-box';
import { useModalBuilder, type ToolbarReference } from '@helpers/modal-building-helper';
import { type DxButton } from 'devextreme-vue';
import {
  DxForm,
  DxLabel,
  DxColCountByScreen,
  DxRequiredRule,
  DxGroupItem,
  DxSimpleItem
} from "devextreme-vue/form";
import { getCurrentInstance, onBeforeMount, onMounted, reactive, ref } from 'vue';
import { useIntl } from '@services/i18n';
import validationEngine from "devextreme/ui/validation_engine";
import { useApi } from '@api/integration';
import { getSelectBoxDefaultProperties } from '@/.shared/helpers/grid-helper';

const api = useApi();
const formInstance = ref<DxForm>();
const intl = useIntl();
const props = defineProps({
  idMarcoComisiones: {
    type: String,
    required: true
  }
});

// Datos del formulario
const formData = reactive({
  marcoComisiones: null
});

onMounted(async () => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!)

  configureButtons(modal);
});

function configureButtons(modal: ReturnType<typeof useModalBuilder>) {
  let okButton: ToolbarReference<DxButton>;
  let cancelButton: ToolbarReference<DxButton>;
  ({ okButton, cancelButton } = modal.standardButtons.addOkCancel());
  
  okButton.update(w => w.text = `${intl.i18n.t("shared.ui.buttons.save")}`);
  okButton.update(w => w.onClick = async () => {
    const result = validationEngine.validateGroup("validacionMarcoComisiones");
    if (result.isValid) {
      modal.close(formData.marcoComisiones);
    }
  });
  
  cancelButton.update(w => w.onClick = () => modal.close(messageBoxResult.cancel));
}

const selectMarcoComisionesOptions = reactive<any>({
  showClearButton: false,
  onValueChanged: (e: any) => {
    formData.marcoComisiones = e.value;
  }
});

onBeforeMount(async () => {
  const marcosComisiones = await api.callStandardApi("getMarcosComisionesList", { showLoading: false });
  selectMarcoComisionesOptions.dataSource = marcosComisiones.filter((item: any) => item.Id !== props.idMarcoComisiones);
});
</script>